<div id="rrhh-info-container">
  <div id="top-block">
    <p class="heading-02-semi-bold grey-900">Información básica</p>
    <!-- Documento -->
    <div class="item-container" id="first-item">
      <p class="subheading-01-semi-bold grey-800">Documento</p>
      <div class="sub-item-container">
        <div id="dropdown-type">
          <qr-dropdown
            [config]="this.dropdownDniType"
            (change)="changeDniType($event)"
            [selected]="this.data.documentType"
            [hasError]="this.errors.documentType"
          ></qr-dropdown>
        </div>
        <div id="input-dni">
          <qr-input
            *ifNodeShow="[NODE_AR]"
            [config]="inputDni"
            [value]="this.data.documentNumber"
            (valueChange)="changeInputDni($event)"
            [hasError]="this.errors.dniValid"
            [isDisabled]="!!this.data.id"
          ></qr-input>
          <qr-input
            *ifNodeShow="[NODE_DO]"
            [config]="inputDniDO"
            [value]="this.data.documentNumber"
            (valueChange)="changeInputDniDO($event)"
            [hasError]="this.errors.dniValid"
            [isDisabled]="!!this.data.id"
          ></qr-input>
          <!--  Para EC y PY Se utiliza otro input porque no debe tener puntos de miles -->
          <qr-input
            *ifNodeShow="[NODE_EC, NODE_GLOBAL, NODE_PY]"
            [config]="inputDniEC"
            [value]="this.data.documentNumber"
            (valueChange)="changeInputDniEC($event)"
            [hasError]="this.errors.dniValid || this.errors.dniNumber"
            [isDisabled]="!!this.data.id"
          ></qr-input>
        </div>
        <div *ngIf="this.loadingDni" id="loader-dni">
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>
        <div
          id="actions-dni"
          [ngClass]="{ 'height-show-dni': this.showDniResult }"
        >
          <div
            *ngIf="this.errors.dniValid"
            id="error-dni"
            class="info-dni-container"
          >
            <div class="icon-dni-container" id="error">
              <div class="icon-dni" id="cross"></div>
            </div>
            <p class="caption-01-regular error-700">{{ this.dniMessage }}</p>
          </div>

          <div
            *ngIf="!this.errors.dniValid"
            id="success-dni"
            class="info-dni-container"
          >
            <div class="icon-dni-container" id="success">
              <div class="icon-dni" id="check"></div>
            </div>
            <p class="caption-01-regular success-700">{{ this.dniMessage }}</p>
          </div>
        </div>
      </div>
      <div
        class="error-container"
        [ngClass]="{ 'error-height': this.errors.documentType }"
      >
        <qr-icon name="error" color="error-700"></qr-icon>
        <p class="paragraph-02-regular nomargin" *ifNodeShow="[NODE_AR]">
          Ingrese un tipo de DNI
        </p>
        <p
          class="paragraph-02-regular nomargin"
          *ifNodeShow="[NODE_EC, NODE_PY, NODE_GLOBAL, NODE_DO]"
        >
          Ingrese un tipo de identificación
        </p>
      </div>
    </div>
    <!-- Documento -->
    <!-- Nombre y Apellido -->
    <!-- Nombre -->
    <div
      class="height-0"
      [ngClass]="{
        'height-show-form-top': this.showDniResult && !this.errors.dniValid
      }"
    >
      <div class="item-space-container">
        <div class="item-container">
          <p class="subheading-01-semi-bold grey-800">
            {{ NODE === NODE_DO ? "Nombres" : "Nombre" }}
          </p>

          <div id="input-name">
            <qr-input
              [config]="inputName"
              [value]="this.data.name"
              [hasError]="this.errors.name"
              (valueChange)="changeInputName($event)"
            ></qr-input>
          </div>
          <div
            class="error-container"
            [ngClass]="{ 'error-height': this.errors.name }"
          >
            <qr-icon name="error" color="error-700"></qr-icon>
            <p class="paragraph-02-regular nomargin">
              Ingrese un nombre válido
            </p>
          </div>
        </div>
        <!-- Nombre -->
        <!-- Apellido -->
        <div class="item-container">
          <p class="subheading-01-semi-bold grey-800">
            {{ NODE === NODE_DO ? "Apellidos" : "Apellido" }}
          </p>
          <div id="input-lastname">
            <qr-input
              [config]="inputLastname"
              [value]="this.data.lastName"
              (valueChange)="changeInputLastName($event)"
              [hasError]="this.errors.lastName"
            ></qr-input>
          </div>
          <div
            class="error-container"
            [ngClass]="{ 'error-height': this.errors.lastName }"
          >
            <qr-icon name="error" color="error-700"></qr-icon>
            <p class="paragraph-02-regular nomargin">
              Ingrese un apellido válido
              <!-- </p> -->
            </p>
          </div>
        </div>
        <!-- Apellido -->
      </div>
      <!-- Nombre y Apellido -->
      <div class="item-space-container">
        <div class="item-container title">
          <div class="flex">
            <p class="subheading-01-semi-bold grey-800">Apodo</p>
            <div class="optional-tag-container">
              <p class="caption-02-bold primary-900">Opcional</p>
            </div>
          </div>
          <div id="input-nickname">
            <qr-input
              [config]="inputNickname"
              [value]="this.data.nickname ?? undefined"
              (valueChange)="changeInputNickname($event)"
            ></qr-input>
          </div>
        </div>
      </div>
      <!-- Apodo -->
      <div class="item-space-container">
        <!-- Género -->
        <div class="item-container">
          <p class="subheading-01-semi-bold grey-800">Género</p>
          <div id="toggle-gender">
            <qr-toggle
              [config]="genderToggle"
              (change)="onChangeGender($event)"
            ></qr-toggle>
          </div>
        </div>
        <!-- Género -->
        <!-- Estado Civil -->
        <div class="item-container">
          <p class="subheading-01-semi-bold grey-800">Estado Civil</p>
          <div id="input-civil-status">
            <qr-dropdown
              [config]="this.dropdownCivilStatus"
              (change)="changeCivilStatus($event)"
              [selected]="
                this.data.civilStatus
                  ? this.data.civilStatus.toLowerCase() === 'union_de_hecho' ||
                    this.data.civilStatus.toLowerCase() === 'union_libre'
                    ? NODE === NODE_DO
                      ? 'Union libre'
                      : 'Union de hecho'
                    : this.data.civilStatus.charAt(0).toUpperCase() +
                      this.data.civilStatus.slice(1).toLowerCase()
                  : ''
              "
            ></qr-dropdown>
          </div>
        </div>
        <!-- Estado Civil -->
      </div>
      <!-- Género y Estado civil -->
      <!-- Fecha de Nacimiento -->
      <div class="item-container">
        <p class="subheading-01-semi-bold grey-800">Fecha de Nacimiento</p>
        <qr-date-picker
          class="input-birthdate"
          [config]="inputBirthdate"
          (datepickerChange)="inputBirthdateChange($event)"
          [hasError]="errors.birthday"
        ></qr-date-picker>
        <div
          class="error-container"
          [ngClass]="{ 'error-height': errors.birthday }"
        >
          <qr-icon name="error" color="error-700"></qr-icon>
          <p class="paragraph-02-regular nomargin">
            Ingrese una fecha de nacimiento con formato válido, por ejemplo:
            18/12/2022. Asegúrese de que la fecha corresponda a un agente mayor
            de 18 años.
          </p>
        </div>
      </div>
      <!-- Fecha de Nacimiento -->

      <!-- Nacionalidad -->
      <div class="item-space-container" *ifNodeShow="[NODE_DO]">
        <div class="item-container title">
          <div class="flex">
            <p class="paragraph-02-bold grey-700">Nacionalidad</p>
          </div>
          <div id="input-nationality">
            <qr-input-autocomplete
              [config]="this.autocompleteNationality"
              [value]="this.nationality"
              [hasError]="this.errors.nationality"
              (selectedChange)="changeNationality($event)"
            ></qr-input-autocomplete>
            <div
              class="error-container"
              [ngClass]="{ 'error-height': errors.nationality }"
            >
              <qr-icon name="error" color="error-700"></qr-icon>
              <p class="paragraph-02-regular nomargin">
                Seleccione una nacionalidad
              </p>
            </div>
          </div>
        </div>
        <!-- Nacionalidad -->
        <!-- Nivel Educativo -->
        <div class="item-container title">
          <div class="flex">
            <p class="paragraph-02-bold grey-700">Nivel educativo</p>
            <div class="optional-tag-container">
              <p class="caption-02-bold primary-900">Opcional</p>
            </div>
          </div>
          <div id="input-education-level">
            <qr-dropdown
              [config]="this.dropdownEducationLevel"
              (change)="changeEducationLevel($event)"
              [selected]="this.educationLevel"
            ></qr-dropdown>
          </div>
        </div>
        <!-- Nivel Educativo -->
      </div>

      <!-- Cantidad de hijos -->
      <div class="item-container title" *ifNodeShow="[NODE_DO]">
        <div class="flex">
          <p class="paragraph-02-bold grey-700">Cantidad de hijos</p>
          <div class="optional-tag-container">
            <p class="caption-02-bold primary-900">Opcional</p>
          </div>
        </div>
        <div id="input-quantity-children">
          <qr-input
            [config]="inputStreetNumber"
            (valueChange)="changeQuantityChilds($event)"
            [value]="this.quantityChilds"
            [hasError]="this.errors.quantityChildren"
          ></qr-input>
          <div
            class="error-container"
            [ngClass]="{ 'error-height': errors.quantityChildren }"
          >
            <qr-icon name="error" color="error-700"></qr-icon>
            <p class="paragraph-02-regular nomargin">
              Ingrese un número válido
            </p>
          </div>
        </div>
      </div>
      <!-- Cantidad de hijos -->

      <!-- Foto del agente -->
      <div class="item-space-container">
        <!-- Contenedor foto -->
        <div class="item-container">
          <div class="title-container">
            <p class="subheading-01-semi-bold grey-800">Foto del agente</p>
            <qr-icon
              (click)="openDialogExample()"
              id="question-icon"
              name="question-mark"
              color="grey-600"
            ></qr-icon>
          </div>
          <div id="photo-container">
            <div
              id="icon-container"
              *ngIf="!this.fileB64 && !this.imagePath; else imageagent"
            >
              <div id="icon-agent"></div>
            </div>
          </div>
          <ng-template #imageagent>
            <div id="photo-agent">
              <img [src]="this.imagePath" />
            </div>
          </ng-template>
          <div
            class="error-container"
            [ngClass]="{ 'error-height': this.errors.photo }"
          >
            <qr-icon name="error" color="error-700"></qr-icon>
            <p class="paragraph-02-regular nomargin">
              {{ this.photoErrorMessage }}
            </p>
          </div>
        </div>
        <!-- Contenedor foto -->
        <!-- Button & Info -->
        <div class="item-container" id="photo-data">
          <div id="add-photo-button">
            <input
              hidden
              type="file"
              multiple="false"
              #uploader
              (change)="addFile($event)"
              accept="image/png, image/jpg, image/jpeg"
            />
            <qr-button
              (click)="uploader.click()"
              [config]="buttonAddPhoto"
            ></qr-button>
          </div>
          <p class="paragraph-02-regular">
            Las dimensiones máximas permitidas <br />
            para la imagen son 600x600 píxeles
          </p>
          <p class="paragraph-02-regular">
            El tamaño máximo permitido para la imagen es <br />
            de 2 MB. Archivos soportados JPG, JPEG, PNG
          </p>
        </div>
        <!-- Button & Info -->
      </div>
      <!-- Foto del agente -->
      <!-- Ubicación -->
      <div class="item-space-container" id="ubication">
        <div class="item-container row-margin" id="w-100">
          <p class="subheading-01-semi-bold grey-800">Ubicación</p>
          <div id="input-ubication" #map>
            <app-ubication-google
              [placeholder]="ubicationPlaceholder"
              [isDisabled]="this.isManualEdit"
              [isFieldAddressNeeded]="true"
              [isInputCleaningEnabled]="false"
              [autocompleteInput]="this.data.fullAdress"
              (byChange)="setAddress($event, map)"
            >
            </app-ubication-google>
          </div>
          <div
            class="error-container"
            [ngClass]="{
              'error-height':
                this.errors.fullAdress &&
                this.NODE !== this.NODE_GLOBAL &&
                this.NODE !== this.NODE_DO
            }"
          >
            <qr-icon name="error" color="error-700"></qr-icon>
            <p class="paragraph-02-regular nomargin">Ingrese una ubicación</p>
          </div>
          <div
            class="error-container"
            [ngClass]="{
              'error-height':
                this.errorUbicationGlobal &&
                (this.NODE === this.NODE_GLOBAL || this.NODE === this.NODE_DO)
            }"
          >
            <qr-icon name="error" color="error-700"></qr-icon>
            <p class="paragraph-02-regular nomargin">
              {{ errorUbicationGlobal }}
            </p>
          </div>
        </div>
        <div id="toggle-ubication" *ifNodeHide="[NODE_GLOBAL, NODE_DO]">
          <div id="toggle-manual-container">
            <mat-slide-toggle
              color="primary"
              [checked]="this.isManualEdit"
              (change)="manualEditChanged($event)"
            ></mat-slide-toggle>
          </div>
          <p class="subheading-01-semi-bold grey-800">Edición manual</p>
          <qr-icon
            matTooltip="Seleccione esta opción si luego de completar el campo de dirección los datos que se muestran nos son correctos"
            id="map-help-icon"
            name="question-mark"
            color="grey-600"
          ></qr-icon>
        </div>

        <!-- Error coords -->
        <div
          class="error-container"
          id="coords-error"
          [ngClass]="{ 'error-height': this.errors.coords }"
        >
          <qr-icon name="error" color="error-700"></qr-icon>
          <p class="paragraph-02-regular nomargin">
            Debe seleccionar un punto en el mapa
          </p>
        </div>
      </div>
      <!-- Ubicación -->
    </div>
  </div>

  <div id="bottom-block">
    <div
      class="height-0"
      [ngClass]="{
        'height-show-form-bottom':
          this.isManualEdit || (this.showDniResult && !this.errors.dniValid)
      }"
    >
      <div
        id="main-ubication"
        *ifNodeHide="[NODE_GLOBAL, NODE_DO]"
        [ngClass]="{
          'height-ubication': !this.errors.fullAdress
        }"
      >
        <!-- Detalle de la ubicación -->
        <div id="ubication-container">
          <!-- Detalle -->
          <div id="ubication-detail">
            <!-- Calle -->
            <div class="item-container title">
              <p class="subheading-01-semi-bold grey-800 title">
                Detalle de la ubicación
              </p>
              <p class="paragraph-02-bold grey-700">Calle</p>
              <div id="input-street">
                <qr-input
                  [config]="inputStreet"
                  (valueChange)="changeInputStreet($event)"
                  [value]="this.data.street"
                  [hasError]="this.errors.street"
                ></qr-input>
              </div>
              <div
                class="error-container"
                [ngClass]="{ 'error-height': this.errors.street }"
              >
                <qr-icon name="error" color="error-700"></qr-icon>
                <p class="paragraph-02-regular nomargin">Ingrese una calle</p>
              </div>
            </div>
            <!-- Calle -->
            <div class="row-ubication">
              <!-- Número -->
              <div class="item-container row-margin">
                <p class="paragraph-02-bold grey-700">Número</p>
                <div id="input-number">
                  <qr-input
                    [config]="inputStreetNumber"
                    (valueChange)="changeInputStreetNumber($event)"
                    [value]="this.data.streetNumber"
                    [hasError]="this.errors.streetNumber"
                  ></qr-input>
                </div>
                <div
                  class="error-container"
                  [ngClass]="{ 'error-height': this.errors.streetNumber }"
                >
                  <qr-icon name="error" color="error-700"></qr-icon>
                  <p class="paragraph-02-regular nomargin">Ingrese un número</p>
                </div>
              </div>
              <!-- Número -->
              <!-- Código Postal -->
              <div class="item-container">
                <p class="paragraph-02-bold grey-700">Código Postal</p>
                <div id="input-cp">
                  <qr-input
                    [config]="inputZipCode"
                    (valueChange)="changeInputZipCode($event)"
                    [value]="this.data.zipCode"
                    [hasError]="this.errors.zipCode"
                  ></qr-input>
                </div>
                <div
                  class="error-container"
                  [ngClass]="{ 'error-height': this.errors.zipCode }"
                >
                  <qr-icon name="error" color="error-700"></qr-icon>
                  <p class="paragraph-02-regular nomargin">Ingrese un C.P.</p>
                </div>
              </div>
              <!-- Código Postal -->
            </div>
            <div class="row-ubication">
              <!-- Piso -->
              <div class="item-container row-margin">
                <p class="paragraph-02-bold grey-700">Piso</p>
                <div id="input-number">
                  <qr-input
                    [config]="inputFloor"
                    (valueChange)="changeInputFloor($event)"
                    [value]="this.data.floor"
                  ></qr-input>
                </div>
              </div>
              <!-- Piso -->
              <!-- Departamento -->
              <div class="item-container">
                <p class="paragraph-02-bold grey-700">Departamento</p>
                <div id="input-cp">
                  <qr-input
                    [config]="inputApartment"
                    (valueChange)="changeInputApartment($event)"
                    [value]="this.data.department"
                  ></qr-input>
                </div>
              </div>
              <!-- Departamento -->
            </div>
            <div class="row-ubication">
              <!-- Pais -->
              <div class="item-container row-margin">
                <p class="paragraph-02-bold grey-700">País</p>
                <div id="input-street">
                  <qr-dropdown
                    [config]="this.dropdownCountry"
                    (change)="changeCountry($event)"
                    [selected]="this.data.country"
                    [hasError]="this.errors.country"
                  ></qr-dropdown>
                </div>
                <div
                  class="error-container"
                  [ngClass]="{ 'error-height': this.errors.country }"
                >
                  <qr-icon name="error" color="error-700"></qr-icon>
                  <p class="paragraph-02-regular nomargin">Ingrese un país</p>
                </div>
              </div>
            </div>
            <div class="row-ubication">
              <!-- Pais -->
              <div class="item-container last-item row-margin">
                <p class="paragraph-02-bold grey-700">Provincia</p>
                <div id="input-number">
                  <qr-dropdown
                    [config]="this.dropdownStates"
                    (change)="changeState($event)"
                    [selected]="this.data.state"
                    [hasError]="this.errors.state"
                    [isDisabled]="!this.data.countryId"
                  ></qr-dropdown>
                </div>
                <div
                  class="error-container"
                  [ngClass]="{ 'error-height': this.errors.state }"
                >
                  <qr-icon name="error" color="error-700"></qr-icon>
                  <p class="paragraph-02-regular nomargin">
                    Ingrese una provincia
                  </p>
                </div>
              </div>
              <!-- Pais -->
              <!-- Provincia-->
              <div class="item-container last-item">
                <p class="paragraph-02-bold grey-700">Ciudad</p>
                <div id="input-cp">
                  <qr-dropdown
                    [config]="this.dropdownCity"
                    (change)="changeCity($event)"
                    [selected]="this.data.city"
                    [hasError]="this.errors.city"
                    [isDisabled]="!this.data.stateId"
                  ></qr-dropdown>
                </div>
                <div
                  class="error-container"
                  [ngClass]="{ 'error-height': this.errors.city }"
                >
                  <qr-icon name="error" color="error-700"></qr-icon>
                  <p class="paragraph-02-regular nomargin">
                    Ingrese una ciudad
                  </p>
                </div>
              </div>
              <!-- Provincia-->
            </div>
          </div>
          <!-- Detalle -->
          <!-- Mapa -->
          <div
            id="map-container"
            [ngClass]="{ 'map-error-container': this.errors.coords }"
          >
            <app-map-osm
              [coords]="this.coords"
              [center]="this.mapcenter"
              [candraw]="false"
              [zoom]="14"
              (onclick)="onclickmap($event)"
            ></app-map-osm>
            <div id="map-info-container">
              <div id="map-info">
                <p
                  class="caption-01-regular grey-700"
                  *ngIf="
                    this.isManualEdit &&
                      this.errors.coords &&
                      (!this.data.latitude || !this.data.longitude);
                    else datacoords
                  "
                >
                  <span *ngIf="!this.isActiveMapDot; else message">
                    Active la edición para seleccionar un punto
                  </span>
                  <ng-template #message>
                    <span> Eligiendo un punto </span>
                  </ng-template>
                </p>
                <ng-template #datacoords>
                  <p class="caption-01-regular grey-700">
                    Latitud:
                    {{
                      this.utilsService.truncateStringNoDots(
                        this.data.latitude || 0,
                        7
                      )
                    }}
                    ∙ Longitud:
                    {{
                      this.utilsService.truncateStringNoDots(
                        this.data.longitude || 0,
                        7
                      )
                    }}
                  </p>
                </ng-template>
              </div>

              <div
                *ngIf="!this.isActiveMapDot; else waitingdot"
                id="marker-icon-container"
                (click)="onClickMarkerMap()"
                [matTooltip]="this.isManualEdit ? 'Activar edición' : ''"
              >
                <div
                  id="marker-container"
                  [ngClass]="{ 'marker-disabled': !this.isManualEdit }"
                ></div>
              </div>
              <ng-template #waitingdot>
                <div
                  *ngIf="this.isActiveMapDot"
                  id="marker-icon-container"
                  (click)="onClickMarkerMap()"
                  matTooltip="Confirmar"
                >
                  <div id="check-container"></div></div
              ></ng-template>
            </div>
          </div>
          <!-- Mapa -->
        </div>
        <!-- Detalle de la ubicación -->
      </div>
      <!-- Contacto -->
      <div id="contact-container">
        <div class="item-container title">
          <p class="subheading-01-semi-bold grey-800 title">Contacto</p>
          <!-- Email personal -->
          <p class="paragraph-02-bold grey-700">E-mail personal</p>
          <div id="input-email">
            <qr-input
              [config]="inputEmail"
              (valueChange)="changeInputEmail($event)"
              [value]="this.data.email"
              [hasError]="this.errors.email"
            ></qr-input>
          </div>
          <div
            class="error-container"
            [ngClass]="{ 'error-height': this.errors.email }"
          >
            <qr-icon name="error" color="error-700"></qr-icon>
            <p class="paragraph-02-regular nomargin">
              Ingrese un e-mail válido
            </p>
          </div>
        </div>
        <!-- Celular-->
        <div class="item-container title">
          <p class="paragraph-02-bold grey-700">Celular</p>
          <div id="input-cellphone">
            <qr-input
              [config]="inputCellphone"
              (valueChange)="
                NODE === NODE_DO
                  ? changeInputCellphoneDO($event)
                  : changeInputCellphone($event)
              "
              [value]="this.data.cellphone"
              [hasError]="this.errors.cellphone"
            ></qr-input>
          </div>
          <p class="caption-01-regular grey-700 hint">
            {{ formatPhone("cel") }}
          </p>
          <div
            class="error-container"
            [ngClass]="{ 'error-height': this.errors.cellphone }"
          >
            <qr-icon name="error" color="error-700"></qr-icon>
            <p class="paragraph-02-regular nomargin">
              Ingrese un número de celular válido
            </p>
          </div>
        </div>
        <!-- Teléfono-->
        <div class="item-container title">
          <div class="flex">
            <p class="paragraph-02-bold grey-700">Teléfono</p>
            <div class="optional-tag-container">
              <p class="caption-02-bold primary-900">Opcional</p>
            </div>
          </div>

          <div id="input-phone">
            <qr-input
              [config]="inputPhone"
              (valueChange)="
                NODE === NODE_DO
                  ? changeInputPhoneDO($event)
                  : changeInputPhone($event)
              "
              [value]="this.data.phone"
              [hasError]="this.errors.phone"
            ></qr-input>
          </div>
          <p class="caption-01-regular grey-700 hint">
            {{ formatPhone("tel") }}
          </p>
           <div
            class="error-container"
            [ngClass]="{ 'error-height': this.errors.phone && !this.warnings.phone}"
          >
            <qr-icon name="error" color="error-700"></qr-icon>
            <p class="paragraph-02-regular nomargin">
                Ingrese un número de teléfono válido
            </p>
          </div>
          <div
            class="error-container"
            [ngClass]="{ 'error-height': this.warnings.phone }"
          >
            <qr-icon name="error" color="error-700"></qr-icon>
            <p class="paragraph-02-regular nomargin">
              El número no es válido, no procedera a guardarse
            </p>
          </div>
        </div>
        <!-- Teléfono -->
      </div>
      <!-- Contacto -->
      <!-- Datos de facturacion (Solo mostrar para argentina y uruguay) -->
      <div id="billing-container" *ngIf="NODE === NODE_AR">
        <p class="subheading-01-semi-bold grey-800 title">
          Datos de facturación
        </p>
        <!-- Tipo de documento -->
        <div class="item-space-container">
          <div class="item-container title">
            <p class="paragraph-02-bold grey-700">Tipo de documento</p>
            <div id="input-doctype">
              <qr-dropdown
                [config]="this.dropdownCuitType"
                (change)="changeCuitType($event)"
                [selected]="this.tipoDoc"
                [hasError]="this.errors.tipoDoc"
              ></qr-dropdown>
            </div>
            <div
              class="error-container"
              [ngClass]="{
                'error-height':
                  this.errors.tipoDoc ||
                  this.errors.cuitFirst ||
                  this.errors.cuitMiddle ||
                  this.errors.cuitLast
              }"
            >
              <qr-icon name="error" color="error-700"></qr-icon>
              <p class="paragraph-02-regular nomargin">
                Ingrese un tipo de doc o CUIT válido
              </p>
            </div>
          </div>
          <!-- Tipo de documento -->
          <!-- Número de CUIT/CUIL -->
          <div class="item-container title">
            <p class="paragraph-02-bold grey-700">Número de CUIT/CUIL</p>
            <div class="flex">
              <div id="input-cuit-number-1">
                <qr-input
                  [config]="inputCuitFirst"
                  (valueChange)="changeInputCuitFirst($event)"
                  [hasError]="this.errors.cuitFirst"
                  [value]="this.cuit.first"
                ></qr-input>
              </div>
              <div id="input-cuit-number-2">
                <qr-input
                  [config]="inputCuitMiddle"
                  (valueChange)="changeInputCuitMiddle($event)"
                  [hasError]="this.errors.cuitMiddle"
                  [value]="this.cuit.middle"
                  (keydown)="isValidDecimalNumber($event)"
                ></qr-input>
              </div>
              <div id="input-cuit-number-3">
                <qr-input
                  [config]="inputCuitLast"
                  (valueChange)="changeInputCuitLast($event)"
                  [hasError]="this.errors.cuitLast"
                  [value]="this.cuit.last.toString()"
                ></qr-input>
              </div>
            </div>
          </div>
          <!-- Número de CUIT/CUIL -->
        </div>
        <!-- Razón social-->
        <div class="item-container title">
          <p class="paragraph-02-bold grey-700">Razón social</p>
          <div id="input-razon-social">
            <qr-input
              [config]="inputRazonSocial"
              (valueChange)="changeInputRazonSocial($event)"
              [value]="this.data.razonSocial"
              [hasError]="this.errors.razonSocial"
            ></qr-input>
          </div>
          <div
            class="error-container"
            [ngClass]="{
              'error-height': this.errors.razonSocial
            }"
          >
            <qr-icon name="error" color="error-700"></qr-icon>
            <p class="paragraph-02-regular nomargin">Ingrese la razón social</p>
          </div>
        </div>
        <!-- Razón social -->

        <!-- Tipo factura y condicion iva -->
        <div class="flex">
          <!-- Tipo de factura-->
          <div class="item-container title">
            <p class="paragraph-02-bold grey-700">Tipo de factura</p>
            <div id="input-invoice-type">
              <qr-dropdown
                [config]="this.dropdownInvoiceType"
                (change)="changeInvoiceType($event)"
                [hasError]="this.errors.fcDeskFee"
                [selected]="this.fcDeskFee"
              ></qr-dropdown>
            </div>
          </div>
          <!-- Tipo de factura -->
          <!-- Condición de IVA-->
          <div class="item-container title">
            <p class="paragraph-02-bold grey-700">Condición de IVA</p>
            <div id="input-iva-condition">
              <qr-dropdown
                [config]="this.dropdownIvaCondition"
                (change)="changeIvaCondition($event)"
                [hasError]="this.errors.fcCondition"
                [selected]="this.fcCondition"
              ></qr-dropdown>
            </div>
          </div>
          <!-- Condición de IVA -->
        </div>
        <div
          class="error-container"
          [ngClass]="{
            'error-height': this.errors.fcCondition || this.errors.fcDeskFee
          }"
        >
          <qr-icon name="error" color="error-700"></qr-icon>
          <p class="paragraph-02-regular nomargin">
            Seleccione una combinación válida
          </p>
        </div>
        <!-- Tipo factura y condicion iva -->

        <!-- Tipo de documento -->
      </div>
      <!-- Datos de facturacion -->
    </div>
  </div>
</div>

<!-- Agregar o editar notificacion -->
<qr-dialog [config]="this.dialogExamplePhoto"></qr-dialog>
